import * as React from 'react';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

import { FormControl } from '@mui/material';

import api from '../../services/api';


const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function CheckboxesTags() {
  const [listValues, setListValues] = React.useState([{
    id: '',
    nome: ''
  }]);

  React.useEffect(() => {
   const values = api.get("regionais")
    values.then((response) => {
      setListValues(response.data)
    })
    .catch((err) => {
      console.error("ops! ocorreu um erro" + err);
    })
  }, []);
  
  return (
    <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
      <Autocomplete
        multiple
        limitTags={2}
        size={"small"} 
        id="checkboxes-tags-demo"
        options={listValues}
        disableCloseOnSelect
        getOptionLabel={(option) => option.nome}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {option.nome}
          </li>
        )}
        style={{ width: 400 }}
        renderInput={(params) => (
          <TextField {...params} label="Regionais" placeholder="" variant="standard" />
        )}
      />
    </FormControl>
  );
}
